import React, { useContext } from 'react';
import { Col, Form, Layout, Row, Typography } from 'antd';
import { Button } from 'components';
import { ReactComponent as IconLink } from 'static/icons/arrow_outward.svg';
import { ReactComponent as IconLoading } from 'static/icons/loading.svg';
import { TeamRegistrationContext } from '../TeamRegistration';
import './style.scss';

export const Step4 = ({ onVisitNDA }: { onVisitNDA: () => void }) => {
  const form = Form.useFormInstance();
  const { loadingNDACheck } = useContext(TeamRegistrationContext);

  const signingUrl = form.getFieldValue('signing_url');

  return (
    <Layout className="team-registration__step-4">
      <Row className="info">
        <Col span={22}>
          <Typography.Title className="info__title" level={4}>
            Sign Non-Disclosure Agreement (NDA)
          </Typography.Title>
          <Typography.Text className="info__text">
            A signed NDA is required so we can share the various forms and documents you will need for the application
            process.
          </Typography.Text>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="form-item_button">
            <Form.Item
              name="nda"
              label="Read and sign NDA online"
              labelCol={{ span: 24 }}
              extra={
                loadingNDACheck
                  ? 'Waiting for the NDA to be signed'
                  : 'After you sign the NDA, you’ll be redirected back to the form.'
              }
              rules={[{ required: true, message: 'Submit NDA' }]}
            >
              <Button
                href={signingUrl}
                target="_blank"
                type="default"
                size="large"
                iconPosition="end"
                icon={loadingNDACheck ? <IconLoading /> : <IconLink />}
                onClick={onVisitNDA}
              >
                {loadingNDACheck ? undefined : 'Open NDA Form'}
              </Button>
            </Form.Item>
          </div>
        </Col>
      </Row>
    </Layout>
  );
};
